import React from "react";
import Navbar from "../Navbar/Navbar";
import { useState } from "react";
import { API } from "../../Redux/actions/API";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import DOMPurify from "dompurify";

export default function PHRequesttoAdmin() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [activamount, setActivation] = useState("");
  const [name, setName] = useState("");
  const [Balance, setBalance] = useState(null);
  const [Epintype, setEpintype] = useState("");

  const [utr, setUtr] = useState("");
  const [usd, setUsd] = useState(0);
  const [Token, setToken] = useState(0);
  const [ethereum, setEthereum] = useState(0);

  const handleChange = (e) => {
    const sanitizedValue = DOMPurify.sanitize(e.target.value).replace(
      /\D/g,
      "",
    );
    const limitedValue = sanitizedValue.slice(0, 8);

    setSearch(limitedValue);
    CheckUserId_Api(limitedValue);
    // CheckUserBalance_Api(limitedValue);
  };

  const CheckUserId_Api = async (value) => {
    try {
      let res = await API.post(
        "/CheckUserId",
        {
          loginid: userId,
          uid: value,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      //   console.log("cuser_Api", res.data);
      if (res?.data?.data === "WrongId") {
        setName("Wrong Id");
      } else {
        setSearch(value);
        setName(res?.data?.data);
      }
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const handleAmount = (e) => {
    const sanitizedValue = DOMPurify.sanitize(e.target.value).replace(
      /\D/g,
      "",
    );
    const limitedValue = sanitizedValue.slice(0, 8);

    setActivation(limitedValue);
    // setUsd(limitedValue);
  };

  // const referral_API = async () => {
  //   if (search) {
  //     try {
  //       let responceRight = await API?.post(
  //         "/FundTransfer",
  //         {
  //           loginid: userId,
  //           uid: search,
  //           amount: activamount,
  //           utrNo: utr,
  //           type: "transfer",
  //         },
  //         {
  //           headers: {
  //             Authorization: jwt_token,
  //           },
  //         }
  //       );

  //       console.log("My_Team", responceRight.data.data);
  //       if (responceRight.data.data == "Successfully Transfered") {
  //         toast.success(responceRight.data.data);
  //         setActivation("");
  //         setSearch("");
  //         setName("");
  //         // setBalance(null);
  //         setUtr("");
  //       } else {
  //         toast.error(responceRight.data.data);
  //       }
  //     } catch (e) {
  //       console.log("error Balance APi", e);
  //       if (
  //         e.response.data.showableMessage ==
  //         "Please login to access this resource"
  //       ) {
  //         dispatch(
  //           updateAuth({ AdminAuth: false, jwt_token: "", userId: null })
  //         );
  //         sessionStorage.clear();
  //         localStorage.clear();
  //         navigate("/");
  //       }
  //     }
  //   } else {
  //     toast.error("Please Fill All The Fields");
  //   }
  // };

  const EPINTransferAPI = async () => {
    if (search) {
      try {
        let responceRight = await API?.post(
          "/PHRequesttoAdmin_byadmin",
          {
            loginid: userId,
            uid: search,
            plan_amount: Epintype,
          },
          {
            headers: {
              Authorization: jwt_token,
            },
          },
        );

        console.clear();
        console.log("My_Team-->", responceRight.data);
        if (responceRight.data.data.result == "Successfull") {
          toast.success(responceRight.data.data.result);
          setActivation("");
          setSearch("");
          setName("");
          // setBalance(null);
          setUtr("");
        } else {
          toast.error(responceRight.data.data.result);
        }
      } catch (e) {
        console.log("error Balance APi", e);
        if (
          e.response.data.showableMessage ==
          "Please login to access this resource"
        ) {
          dispatch(
            updateAuth({ AdminAuth: false, jwt_token: "", userId: null }),
          );
          sessionStorage.clear();
          localStorage.clear();
          navigate("/");
        }
      }
    } else {
      toast.error("Please Fill All The Fields");
    }
  };

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div
          id="content"
          class="content col-lg-12 col-sm-12 ng-scope"
          ng-controller="activateidByZeroPinCtl"
        >
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">PH Request by Admin </h4>
            </div>
            <div
              class="panel-body table-rep-plugin"
              style={{ padding: "8px", overflowY: "scroll" }}
            >
              <div class="row">
                <div class="box col-md-12">
                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-6 mr-30">
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <span
                                  class="metamaskConnection"
                                  style={{ color: "#fff" }}
                                ></span>
                                <div className="d-flex justify-content-between">
                                  <h1> PH Request by Admin </h1>
                                  <Link
                                    to="/PHRequestAdminHistory"
                                    id="btnactive"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 10px",
                                      marginTop: "20px",
                                      background: "#0d37a5",
                                    }}
                                  >
                                    PH Request by Admin History
                                  </Link>
                                </div>
                                {/* <!---onclick number increase start--> */}
                                <div className="form-group">
                                  <label>User Id</label>
                                  <input
                                    type="text"
                                    // inputMode="numeric"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter User Id"
                                    value={search}
                                    onChange={handleChange}
                                  />
                                  {name && (
                                    <p
                                      className={
                                        name === "Wrong Id"
                                          ? "text-danger"
                                          : "text-success"
                                      }
                                    >
                                      {name}
                                    </p>
                                  )}
                                </div>
                                <div className="form-group">
                                  <label>Payment Type</label>
                                  <br />
                                  <div>
                                    <select
                                      onChange={(e) =>
                                        setEpintype(e.target.value)
                                      }
                                      value={Epintype}
                                      className="form-control  rounded-2s"
                                    >
                                      <option value="">Select Epin Type</option>
                                      {/* <option value="1000">1000</option> */}
                                      <option value="299">500</option>
                                    </select>
                                  </div>
                                </div>

                                <div class="joinbtn d-flex  me-auto">
                                  <button
                                    id="btnactive"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 20px",
                                      marginTop: "20px",
                                    }}
                                    onClick={() => EPINTransferAPI()}
                                  >
                                    PH Request to Admin
                                  </button>
                                  {/* <button
                                    id="btnactive"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 20px",
                                      marginTop: "20px",
                                    }}
                                    onClick={() => referral_API_dedut()}
                                  >
                                    Deduct Fund
                                  </button> */}
                                </div>
                                {/* <div class="joinbtn d-flex flex-row-reverse me-auto">
                                  <button
                                    id="btnactive"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 20px",
                                      marginTop: "20px",
                                    }}
                                    onClick={() => Deduct_API()}>
                                    Fund Deduct
                                  </button>
                                </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
